<template>
	<div class="NewLists-div">
		<div class="NewLists-top">
			<Navbar></Navbar>
		</div>
    <div class="NewLists-banner">
      <img src="../assets/images/banner2.png" />
    </div>
    <div class="NewLists-content">
      <div class="NewLists-content-div">
        <div class="NewLists-con-tab">
          <div class="NewLists-con-tabtitle">产品中心</div>
          <ul class="NewLists-con-tabul">
            <router-link tag="li" v-for="(item, index) in conditionArr[0].data"
                :key="index"
                class="NewLists-con-tabli"
                :to="{path: '/ProductsList', query: {type: index}}"
                :class="index == type ? 'NewLists-con-tabli-active' : ''">{{item.name}}</router-link>
          </ul>
        </div>
        <div class="NewLists-con-news">
          <div class="NewLists-con-news-search">
            <div class="NewLists-news-search-title">产品中心</div>
            <div class="NewLists-news-search-input">
              <input type="text" placeholder="请输入搜索关键字" v-model="searchValue" /><i class="el-icon-search"></i>
            </div>
          </div>
          <div class="NewLists-con-news-table">
            <Productstable1 :type="type" :data="productList" :searchValue="searchValue"></Productstable1>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { conditionArr } from "@/common/condition";
import request from "../util/request";
	import Navbar from "../components/Navbar.vue";
	import Productstable1 from "../components/Productstable1.vue";
	export default {
		name: "ProductsList",
		components: {
			Navbar,
      Productstable1
		},
		data() {
		  return {
        conditionArr,
        type: null,
        searchValue: '',
        
        activeindex: -1, // 鼠标移入的
        showindex: 0, // 展示的新闻列表
        activeName: "1", // tab值
        newslist:[{ // 新闻列表
          id: 1,
          tab: "标题1",
          list:[{
            id: 11,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          },{
            id: 22,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          }]
        },
        {
          id: 2,
          tab: "标题2",
          list:[{
            id: 11,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          },{
            id: 22,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2021 01-01"
          }]
        },
        {
          id: 3,
          tab: "标题3",
          list:[{
            id: 11,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2022 01-01"
          },{
            id: 22,
            img: require("../assets/images/banner@2x.png"),
            title: "顶峰相见！法国阿根廷会师世界杯",
            content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
            time: "2023 01-01"
          }]
        }],
        productList: []
		  }
		},
    watch: {
      $route() {
        // this.getList()
        this.type = this.$route.query.type
      }
    },
    mounted() {
      this.getList()
      this.type = this.$route.query.type
      this.searchValue = this.$route.query.keywords || ''
    },
    methods: {
      doSearch() {

      },
      async getList() {
        let list = await request.get('/product/list')
        this.productList = list
      },
      showactive(num) {
        this.activeindex = num;
      },
      hideactive() {
        this.activeindex = -1;
      },
      shownewlist(num) {
        this.showindex = num;
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
	}
</script>

<style scoped>
  .NewLists-banner {
    width: 100%;
    min-width: 1200px;
    height: 350px;
  }
  
  .NewLists-banner img {
    width: 100%;
    height: 100%;
  }
  
  .NewLists-content {
    min-width: 1200px;
    background-color: #f5f5f5;
  }
  
  .NewLists-content-div {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  
  .NewLists-con-tab,
  .NewLists-con-news {
    border-radius: 10px;
    overflow: hidden;
  }
  
  .NewLists-con-tab {
    background-color: #fff;
    margin-right: 10px;
    width: 180px;
    min-height: 250px;
    flex-shrink: 0;
  }
  
  .NewLists-con-tabtitle {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    padding: 10px 15px;
    box-sizing: border-box;
  }
  
  .NewLists-con-tabli {
    color: #787878;
    background-color: #f5f5f5;
    padding: 10px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #fff;
    cursor: pointer;
    position: relative;
  }
  
  .NewLists-con-tabli-moveactive {
    color: #232CEA;
    background-color: rgba(35, 44, 234, 0.10);
  }
  
  .NewLists-con-tabli-active {
    color: #232CEA;
    font-weight: bold;
  }
  
  .NewLists-con-tabli-active::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 2px;
    height: 100%;
    z-index: 1;
    background: #232cea;
  }
  
  .NewLists-con-news {
    flex-grow: 2;
    background-color: #fff;
    padding: 20px;
  }
  
  .NewLists-con-news-search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .NewLists-news-search-title {
    font-size: 16px;
    color: #262626;
    font-weight: bold;
  }
  
  .NewLists-news-search-input input {
    border: none;
    font-size: 14px;
    outline: none;
  }
  
  .NewLists-news-search-input {
    border-radius: 5px;
    border: 1px solid #a9a9a9;
    padding: 5px 10px;
    box-sizing: border-box;
  }
  
  .NewLists-con-news-table {
    overflow-x: auto;
  }
</style>